import { assign, map, isEmpty, findIndex } from "lodash";
import store from '../../stores/index';
import http from '../../api/index'
import { parseUser, parseClient } from '../../service/parser'

export default function createAccountModule() {
    const PAGE_LENGTH = 32;

    return {
        namespaced: true,

        state: () => ({
            clients: [],
            users: [],
            admins: [],
            selectedClient: {},
            selectedUser: {},
            clientGroups: [],
            partial: true,
            timestamp: Date.now()
        }),

        getters: {
            clients: (state) => state.clients,
            users: (state) => state.users,
            admins: (state) => state.admins,
            clientGroups: (state) => state.clientGroups,
            selectedClient: (state) => state.selectedClient,
            selectedUser: (state) => state.selectedUser,
            partial: (state) => state.partial,
            timestamp: (state) => state.timestamp,
        },

        actions: {
            getUser({ commit, state }, options = {}) {
                let userID = options.userID;
                let role = store.getters['profile/role'];

                if(userID == state.selectedUser.id){
                    return new Promise(resolve => {
                        resolve(state.selectedUser);
                    })
                }

                let url;
                if(role === 'group-admin'){
                    url = '/group-admin/user/get';
                }else if(role === 'admin' || role === 'super-admin'){
                    url = '/admin/user/get';
                }else{
                    url = '/manager/user/get';
                }

                let params = { id: userID };
                return http.get(url, {params: params})
                    .then(res => {
                        let account = res.data;
                        let user = parseUser(account);
                        commit('setSelectedUser', user);
                        return user;
                    })
            },
            updateUser({ commit, state }, data = {}) {
                let role = store.getters['profile/role'];
                let url;

                if(role === 'group-admin'){
                    url = '/group-admin/user/update';
                }else if(role === 'admin' || role === 'super-admin'){
                    url = '/admin/user/update';
                }else{
                    url = '/manager/user/update';
                }
                return http.patch(url, data)
                    .then(res => {
                        let user = res.data;
                        commit('setSelectedUser', user);
                        return user;
                    })
            },

            updateAdmin({ commit, state }, data = {}) {
                return http.patch('/admin/update', data)
                    .then(res => {
                        let user = res.data;
                        commit('setSelectedUser', user);
                        return user;
                    })
            },

            resetPasswordUser({ commit, state }, options = {}) {
                let userId = options.userID;
                let role = store.getters['profile/role'];
                let url;

                if(role === 'group-admin'){
                    url = '/group-admin/user/reset-password/';
                }else if(role === 'admin' || role === 'super-admin'){
                    url = '/admin/user/reset-password/';
                }else{
                    url = '/manager/user/reset-password/';
                }

                return http.get(url + userId)
                    .then(res => {
                        let user = res.data;
                        commit('setSelectedUser', user);
                        return user;
                    })
            },

            updateUserStatus({ commit, state }, data = {}) {
                let role = store.getters['profile/role'];
                let url;

                if(role === 'group-admin'){
                    url = '/group-admin/user/update-status/';
                }else if(role === 'admin' || role === 'super-admin'){
                    url = '/admin/user/update-status';
                }else{
                    url = '/manager/user/update-status';
                }

                return http.patch(url, data)
                    .then(res => {
                        let user = res.data;
                        commit('setSelectedUser', user);
                        return user;
                    })
            },

            getClients({ commit, state }, options = {page: 0}) {
                if(options.page == 0){
                    commit('clearClients');
                }

                let params = {limit: PAGE_LENGTH};

                if( options.page){
                    params.offset = options.page * PAGE_LENGTH;
                }

                if(options.searchString){
                    params.search_string = '%' + options.searchString + '%';
                }

                let role = store.getters['profile/role'];
                let url = role === 'group-admin' ? 'group-admin/client/list' : 'admin/client/list';

                return http.get(url, {params:  params})
                    .then(res => {
                        let clients = map(res.data.clientList, (account) => {
                            let item = parseClient(account);
                            if(account.client_group){
                                item.group_name = account.client_group.name
                            }
                            return item;
                        });

                        commit('pushClients', clients);
                        commit('setPartial', res.data.partial_list);
                        return clients;
                    })
            },

            getClient({ commit, state }, options = {}) {
                let clientID = options.clientID;
                let role = store.getters['profile/role'];
                let url, params;

                if(clientID == state.selectedClient.id){
                    return new Promise(resolve => {
                        resolve(state.selectedClient);
                    })
                }

                if(role === 'group-admin'){
                    params = { id: clientID };
                    url = 'group-admin/client/get';
                }else if(role === 'admin' || role === 'super-admin'){
                    params = { id: clientID };
                    url = 'admin/client/get';
                }else{
                    params = {};
                    url = 'manager/client/get';
                }

                return http.get(url, {params:  params})
                    .then(res => {
                        let account = res.data;
                        let client = parseClient(account);
                        commit('setSelectedClient', client);
                        return client;
                    })
            },

            getAdmins({ commit, state }, options = {page: 0}) {
                return http.get('admin/list')
                    .then(res => {
                        let admins = map(res.data, (account) => {
                            return parseUser(account);
                        });

                        commit('setAdmins', admins);
                        return admins;
                    })
            },

            getUsers({ commit, state }, options = {page: 0}) {
                let params, url;
                let role = store.getters['profile/role'];

                if(role === 'group-admin'){
                    params = { client_id: options.clientID };
                    url = 'group-admin/user/list';
                }else if(role === 'admin' || role === 'super-admin'){
                    params = { client_id: options.clientID };
                    url = 'admin/user/list';
                }else{
                    params = {};
                    url = 'manager/user/list';
                }

                return http.get(url, {params:  params})
                    .then(res => {
                        let users = map(res.data, (account) => {
                            return parseUser(account);
                        });

                        commit('setUsers', users);
                        return users;
                    })
            },


            getClientGroups({ commit, state }) {
                if(state.clientGroups.length){
                    return state.clientGroups;
                }else{
                    let params = {};
                    return http.get('admin/client-group/list', {params:  params})
                        .then(res => {
                            commit('setClientGroups', res.data);
                            return res.data;
                        });
                }
            },

            reloadClientGroups({ commit, state }) {
                let params = {};
                return http.get('admin/client-group/list', {params:  params})
                    .then(res => {
                        commit('setClientGroups', res.data);
                        return res.data;
                    });
            },

            updateClient({ commit, state }, data = {}) {
                return http.post('admin/client/update', data)
                    .then(res => {
                        let data = res.data;
                        let client = {
                            id: data.id,
                            name: data.name,
                            account_number: data.account_number,
                            group_id: data.group_id
                        };
                        commit('setSelectedClient', client);
                        return client;
                    })
            },


            setEmptyClient({ commit, state }) {
                commit('setEmptyClient');
            }
        },

        mutations: {
            clearClients(state){
                state.clients = [];
                state.timestamp = Date.now();
            },
            setClientGroups(state, groups){
                state.clientGroups = groups;
                state.timestamp = Date.now();
            },
            setClients(state, clients){
                state.clients = clients;
                state.timestamp = Date.now();
            },
            setUsers(state, users){
                state.users = users;
                state.timestamp = Date.now();
            },
            clearUsers(state){
                state.users = [];
                state.timestamp = Date.now();
            },
            setAdmins(state, admins){
                state.admins = admins;
                state.timestamp = Date.now();
            },
            pushClients(state, clients) {
                state.clients.push(...clients);
                state.timestamp = Date.now();
            },
            setSelectedClient(state, client){
                state.selectedClient = client;
                state.timestamp = Date.now();
            },
            setSelectedUser(state, user){
                state.selectedUser = user;
                state.timestamp = Date.now();
            },
            setEmptyClient(state){
                state.selectedClient = {
                    id: 0,
                    name: '',
                    group_id: '',
                    account_number: ''
                };
                state.timestamp = Date.now();
            },
            setPartial(state, value){
                state.partial = value;
                state.timestamp = Date.now();
            }
        },
    }
}
